import { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { Article, Dropdown, LeadingTitle, FooterSection, Pagination } from "@components";
import { Search, Filter, ChevronDown } from "@icons";
import { InspirationAPI, ShortDescriptionAPI } from "@api";
import { useQuery } from "@hooks";
import { useTranslation } from "react-i18next";

const ListInspirationContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const ListInspiration = function () 
{
  const { t } = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);

  return (
    <ListInspirationContainer>
      <LeadingTitle
        title={t("inspirasi_title")}
        subtitle={t("inspirasi_desc")}
      />
      <Body />
      <FooterSection currentPage={t("inspirasi_page")}/>
    </ListInspirationContainer>
  );
};

const Body = function () 
{
  const { t } = useTranslation();
  const [news, setNews] = useState({});
  const [year, setYear] = useState(null);
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [yearCollection, setYearCollection] = useState();
  const query = useQuery();
  const history = useHistory();
  const page = query.get("page") || 1;

  const generateYear = () => 
  {
    const currentYear = new Date().getFullYear();
    let collection = [{
      year: t("semua"),
      selected: false,
    }];

    for (let x = currentYear - 10; x <= currentYear; x++)
    {
      collection.push({
        year: x,
        selected: false,
      });
    }

    setYearCollection(collection);
  };

  useEffect(() => {
    generateYear();
  }, []);

  useEffect(() => {
    const loadNews = async () => {
      const filter = {
        page,
        q: searchQuery,
        year: year
      }

      const { data } = await InspirationAPI(`?${queryString.stringify(filter)}`);
      setNews(data?.data || {});
    };

    loadNews();
  }, [searchQuery, year, page]);

  const handleUpdateSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleSearch = () => {
    history.push({
      search: `?`
    })
    setSearchQuery(search);
  };

  const handleYear = (year) => {
    history.push({
      search: `?`
    })

    setYear(isNaN(parseFloat(year)) ? null : year);
  };

  const createPagination = () => {
    const { total, per_page } = news;
    return {
      totalItems: total,
      currentPage: +page,
      limit: per_page,
    }
  }

  return (
    <div className="news-room-page">
      <div className="news-room-page-content">
        <div className="news-room-page-content-left">
          {news?.item?.map((data, i) => {
            return (
              <Article
                key={i}
                creator={data.oleh}
                title={data.judul}
                subtitle={data.deskripsi?.replace(/(<([^>]+)>)/gi, "")}
                readMore="tr"
                slug={data.slug}
                largeTitle="title-large"
                type={"inspirasi"}
              />
            );
          })}
          <nav 
            className="pagination-box d-flex align-items-center justify-content-center" 
            aria-label="News Pagination"
          >
            <ul className="pagination">
              <Pagination {...createPagination()} />
            </ul>
          </nav>
        </div>
        <div className="news-room-page-content-right">
          <div className="label-box">
            <Search fill="#85714d" className="label-box-icon" />
            <div className="label-box-title">{t("pencarian")}</div>
          </div>
          <div className="input-box">
            <Form.Group controlId="search">
              <Form.Control
                type="text"
                placeholder={t("masukan_kata_kunci")}
                value={search}
                onChange={handleUpdateSearch}
              />
            </Form.Group>
          </div>
          <div className="button-box">
            <Button
              className="w-100 justify-content-center"
              variant="warning"
              onClick={handleSearch}
            >
              {t("search")}
            </Button>
          </div>
          <div className="label-box">
            <Filter fill="#85714d" className="label-box-icon" />
            <div className="label-box-title">Filter</div>
          </div>
          <div className="filter-box">
            <div className="filter-item">
              <Dropdown
                label={t("pilih_tahun")}
                title={year || t("semua")}
                className="custom-dropdown"
                icon={ChevronDown}
                items={yearCollection}
                onClick={handleYear}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListInspiration;
